import React from 'react'
import classNames from 'classnames'
import { HiChevronLeft }  from "react-icons/hi"

const Prev = props => {

	const { currentPage, pagerClass, onPrev } = props

	const disabled = currentPage <= 1 

	const onPrevClick = e => {
		if(disabled) {
			return 
		}
		onPrev(e)
	}

	const pagerPrevClass = classNames(
		pagerClass.default, 
		'pagination-pager-prev', 
		disabled ? pagerClass.disabled : pagerClass.inactive
	)

	return (
		<button type="button" className={classNames(pagerPrevClass, 'border-0 bg-transparent')} disabled={disabled} onClick={onPrevClick} aria-label="Önceki sayfa">
			<HiChevronLeft />
		</button>
	)
}

export default Prev
